import React, { useState, useEffect, useRef } from "react";
// eslint-disable-next-line standard/object-curly-even-spacing
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.scss";
import { connect } from "react-redux";
import { Helmet } from 'react-helmet';
import { bindActionCreators } from "redux";
import {  getAboutUsFinancialInfo } from "../actions";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { getRouting, formDataGenerator, checkIframeContent} from "../../../../../utils/common";
import "./style.scss";
import PaginationComponent from "../../../general/PaginationComponent";
import PageNotFound from "../../PageNotFound";

const FinancialInformation = (props) => {
  const {    
    getAboutUsFinancialInfo,
    financialInformation,
    financialInfo,
    location: { pathname },
  } = props;

  const getCurrent = (nc) => {
    switch (nc) {
      case 'annual-reports':
        return 0;
      case 'financial-results':
        return 1;
      case 'shareholder-presentation':
        return 2;
      default:
        return 0;
    }
  };

  const current = pathname.split('/')[3];
  const [selectedIndexTab, setSelectedIndexTab] = useState(getCurrent(current));
  const [currentPageurl, setCurrentPageurl] = useState("annual-reports");
  const [anualYears, setAnualYears] = useState([]);
  const [financialYears, setFinancialYears] = useState([]);
  const [shareholderYears, setShareholderYears] = useState([]);
  const [defaultYear, setDefaultYear] = useState();
  const [defaultText, setDefaultText] = useState();
  const [activePage, setActivePage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [totalRecords, setTotalRecords] = useState(10);
  const [annualReportsData, setAnnualReports] = useState();
  const [financialResultsData, setFinancialResult] = useState();
  const [shareholderPpt, setShareholderPpt] = useState();
  const [shareholderPptAudio, setShareholderPptAudio] = useState();
  const [overView, setOverView] = useState();
  const [data, setData] = useState([]);
  const [metaData, setMetaData] = useState("");
  const [flag , setFlag] = useState(false);

  const getPaginatedData = (page) => {
    loadData(page);
  };

  const loadData = (page) => {
    const offsetValue = limit * (page - 1);
    let params = {
      title: defaultText ? defaultText : "",
      year: defaultYear ? defaultYear : "",
      limit: limit,
      offset: limit * (page - 1),
    }
    if (currentPageurl && currentPageurl !== undefined) {
      getAboutUsFinancialInfo({},formDataGenerator(params), currentPageurl);
    }

  }
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(()=>{
    if(flag == true){
      setFlag(false);
    }
  },[flag]);


  useEffect(() => {
    if (current && current !== '') {
      setCurrentPageurl(current)
    } else {
      setCurrentPageurl('annual-reports')

    }
  }, [current])


  useEffect(() => {

    if (currentPageurl === 'annual-reports') {
      setSelectedIndexTab(0)
    }
    if (currentPageurl === 'financial-results') {
      setSelectedIndexTab(1)
    }
    if (currentPageurl === 'shareholder-presentation') {
      setSelectedIndexTab(2)
    }

  }, [currentPageurl])

  useEffect(() => {
    if (currentPageurl && currentPageurl !== undefined) {
      let params = {
        title: defaultText ? defaultText : "",
        year: defaultYear ? defaultYear : "",
        limit: limit,
        offset: offset,
      }
      // getAboutUsFinancialInfo({},formDataGenerator(params), currentPageurl);
      if(window.location.pathname.split('/')[3] == "annual-reports"){
        !(financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.annualReport && financialInformation.financialInformation.annualReport.data && (params.title == "" && params.year == "") && flag == false)
        && getAboutUsFinancialInfo({},formDataGenerator(params), currentPageurl);
      }
      if(window.location.pathname.split('/')[3] == "financial-results"){
        !(financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.financialResult && financialInformation.financialInformation.financialResult.data && (params.title == "" && params.year == "") && flag == false)
        && getAboutUsFinancialInfo({},formDataGenerator(params), currentPageurl);
      }
      if(window.location.pathname.split('/')[3] == "shareholder-presentation"){
        !(financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.shareholderPpt && financialInformation.financialInformation.shareholderPpt.data && (params.title == "" && params.year == "") && flag == false)
        && getAboutUsFinancialInfo({},formDataGenerator(params), currentPageurl);
      }
    }
  }, [defaultYear, defaultText, currentPageurl])

  useEffect(() => {

    if (currentPageurl === 'annual-reports' && financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.annualReport &&financialInformation.financialInformation.annualReport.meta) {
      setMetaData(financialInformation.financialInformation.annualReport.meta)
    }
    if (currentPageurl === 'financial-results' && financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.financialResult &&financialInformation.financialInformation.financialResult.meta) {
      setMetaData(financialInformation.financialInformation.financialResult.meta)

    }
    if (currentPageurl === 'shareholder-presentation' && financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.shareholderPpt && financialInformation.financialInformation.shareholderPpt.meta) {
      setMetaData(financialInformation.financialInformation.shareholderPpt.meta)

    }

  }, [currentPageurl,financialInformation])

  useEffect(() => {
    if(window.location.pathname.split('/')[3] == "annual-reports"){
      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.annualReport) {
        setAnnualReports(financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.annualReport.data)
        setOverView(financialInformation.financialInformation.annualReport.overview)
      }

      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.annualReport && financialInformation.financialInformation.annualReport.Years && financialInformation.financialInformation.annualReport.Years.values) {
        setAnualYears(financialInformation.financialInformation.annualReport.Years.values)
      }

      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.annualReport && financialInformation.financialInformation.annualReport.total) {
        setTotalRecords(financialInformation.financialInformation.annualReport.total)
      }
    }

    if(window.location.pathname.split('/')[3] == "financial-results"){
      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.financialResult) {
        setFinancialResult(financialInformation.financialInformation.financialResult.data)
        setOverView(financialInformation.financialInformation.financialResult.overview)
      }

      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.financialResult && financialInformation.financialInformation.financialResult.Years && financialInformation.financialInformation.financialResult.Years.values) {
        setFinancialYears(financialInformation.financialInformation.financialResult.Years.values)
      }

      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.financialResult && financialInformation.financialInformation.financialResult.total) {
        setTotalRecords(financialInformation.financialInformation.financialResult.total)
      }
    }

    if(window.location.pathname.split('/')[3] == "shareholder-presentation"){
      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.shareholderPpt) {
        setShareholderPpt(financialInformation.financialInformation.shareholderPpt.data)
        setOverView(financialInformation.financialInformation.shareholderPpt.overview)

      }
      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.shareholderPpt && financialInformation.financialInformation.shareholderPpt.Years && financialInformation.financialInformation.shareholderPpt.Years.values) {
        setShareholderYears(financialInformation.financialInformation.shareholderPpt.Years.values)
      }
      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.shareholderPpt && financialInformation.financialInformation.shareholderPpt.total) {
        setTotalRecords(financialInformation.financialInformation.shareholderPpt.total)
      }
      if (financialInformation && financialInformation.financialInformation && financialInformation.financialInformation.shareholderPpt && financialInformation.financialInformation.shareholderPpt.audio) {
        setShareholderPptAudio(financialInformation.financialInformation.shareholderPpt.audio)
        setOverView(financialInformation.financialInformation.shareholderPpt.overview)
      }
    }
    window.scrollTo(0, 0)

  }, [financialInformation])

  useEffect(() => {
    $(function () {
      $('audio').audioPlayer({
        classPrefix: 'audioplayer',
      });
    });

  }, [])

  const handleApiCall = async (e, tabName) => {
    setDefaultYear('');
    setDefaultText('');
    setActivePage(1);
    setCurrentPageurl(tabName);
    setFlag(true);
  };

  const handleSelectChange = (event) => {
    setDefaultYear(event.target.value);
    setActivePage(1);
  }

  const handleSearch = async (e) => {
    setDefaultText(e.target.value);
    setActivePage(1);
    setFlag(true);
  };

  //dropdown start

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropDown = () => {
    setIsOpen(!isOpen);
  };

  const handleClickOut = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOut);
    return () => {
      document.removeEventListener("click", handleClickOut);
    };
  }, [isOpen]);

  //dropdown end

  //tryacord start
  const [selected, setSelected] = useState(null);
  const audioRefs = useRef([]);
  useEffect(() => {
    audioRefs.current.forEach((audio, index) => {
      if(audio){
        audio.addEventListener('play', () => handlePlay(index));
      }
    });
    return () => {
      audioRefs.current.forEach((audio, index) => {
        if(audio){
          audio.removeEventListener('play', () => handlePlay(index));
        }
      });
    };
  }, [shareholderPptAudio]);
  const handlePlay = (index) => {
    audioRefs.current.forEach((audio, i) => {
      if (i !== index && !audio.paused) {
        audio.pause();
        audio.currentTime = 0;
      }
    });
  };

  const toggle = (index) => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  //tryacord end
  return (
    <div className={checkIframeContent() ? "wrapper":""}>
      {current == "annual-reports" || current == "financial-results" || current == "shareholder-presentation" ? <>
      {metaData && metaData !== null && <Helmet>
        <title>{metaData.title ? metaData.title : ""}</title>
        <meta name="description" content={metaData.description ? metaData.description : ""} />
        <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
        <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
        <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
        <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
        <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
      </Helmet>}

      <section className="aboutHead">
        <div className="container">
          <div className="d-flex dropdowncls">
            <div class="dropdown me-auto" ref={dropdownRef}>
              <div
                id="dropdownMenuLink"
                // data-bs-toggle="dropdown"
                // aria-expanded="false"
                onClick={toggleDropDown} 
              >
                <h1>
                  <span>Financial</span> Information
                  <img
                    className="ms-2"
                    src="/images/New/redDownArrow.svg"
                    alt="red arrow"
                  />
                </h1>
              </div>
              {isOpen && (
                <ul
                  className="dropdown-body"
                  aria-labelledby="dropdownMenuLink"
                >
                  {overView &&
                    overView.length > 0 &&
                    overView.map((over, index) =>
                      over.linkName === "Financial Information" ? (
                        ""
                      ) : (
                        <li>
                          {checkIframeContent() ? <a
                            className="dropdown-item fw-bold"
                            href={over.routeConstant}
                          >
                            {over.linkName}
                          </a>:<Link
                                className="dropdown-item fw-bold"
                                to={getRouting(over.routeConstant)}
                              >
                              {over.linkName}
                          </Link>}
                        </li>
                      )
                    )}
                </ul>
              )}
              {/* <ul class="dropdown-body" aria-labelledby="dropdownMenuLink">
                {overView &&
                  overView.length > 0 &&
                  overView.map((over, index) =>
                    over.linkName === "Financial Information" ? (
                      ""
                    ) : (
                      <li>
                        <a
                          class="dropdown-item fw-bold"
                          href={over.routeConstant}
                        >
                          {over.linkName}
                        </a>
                      </li>
                    )
                  )}
              </ul> */}
            </div>
            <nav
              aria-label="breadcrumb"
              className="align-self-center breadCrumbCust d-md-inlin"
            >
              <ol className="breadcrumb mb-0">
                {checkIframeContent() && <li className="breadcrumb-item d-flex">
                  <a href="/">Home </a>
                </li>}
                <li className="breadcrumb-item d-flex">
                  <Link to={getRouting("/about-us", "About Us")}>
                    <div>
                      <p>About Us</p>
                    </div>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item d-flex active breadcolor"
                  aria-current="page"
                >
                  Financial Information
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section className="customSlick">
        <Tabs className="customTab" selectedIndex={selectedIndexTab}>
          <div className="container containerSlick">
            <div className="row">
              <div className="col-md-12 mx-auto">
                <TabList>
                  <div className="mrg_40">
                    <div className="tabSlickInfo slickOptions">
                      <Link
                        to={getRouting(
                          "/about-us/financial-information/annual-reports",
                          "Annual Reports"
                        )}
                      >
                        <Tab
                          onClick={async (e) =>
                            await handleApiCall(e, "annual-reports")
                          }
                          tabFor="0"
                          value={0}
                        >
                          <div>
                            <p>Annual Reports / Postal Ballot</p>
                          </div>
                        </Tab>
                      </Link>
                      <Link
                        to={getRouting(
                          "/about-us/financial-information/financial-results",
                          "Financial Results"
                        )}
                      >
                        <Tab
                          onClick={async (e) =>
                            await handleApiCall(e, "financial-results")
                          }
                          tabFor="1"
                          value={1}
                        >
                          <div>
                            <p>Financial Results</p>
                          </div>
                        </Tab>
                      </Link>
                      <Link
                        to={getRouting(
                          "/about-us/financial-information/shareholder-presentation",
                          "Shareholder Presentation"
                        )}
                      >
                        <Tab
                          onClick={async (e) =>
                            await handleApiCall(e, "shareholder-presentation")
                          }
                          tabFor="2"
                          value={2}
                        >
                          <div>
                            <p>Shareholder Presentations</p>
                          </div>
                        </Tab>
                      </Link>
                    </div>
                  </div>
                </TabList>
                <div className="tabSlickContentInfo">
                  <TabPanel>
                    <div>
                      <div className="mrg_40">
                        <div className="d-flex d-md-block flex-column-reverse">
                          <div className="row">
                            <div className="col-md-9">
                              <p className="mt-3 fsize">
                                Select the Financial Year to View Reports
                              </p>
                              <div className="row mt-3">
                                <div className="col-md-6 mb-4">
                                  <div className="input-group inputt">
                                    <select
                                      className="form-select year-drop py-3"
                                      id="inputGroupSelect04"
                                      aria-label="Example select with button addon"
                                      onChange={handleSelectChange}
                                    >
                                      {anualYears &&
                                        Object.keys(anualYears).length > 0 &&
                                        Object.keys(anualYears).map(
                                          (year, index) => (
                                            <option value={year}>
                                              {Object.values(anualYears)[index]}
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-6 mb-4">
                                  <div className="input-group mb-3 ipgroup">
                                    <span
                                      className="input-group-text serchcolor"
                                      id="inputGroup-sizing-default"
                                    >
                                      <img
                                        className="search"
                                        src="/images/New/grey-search.svg"
                                        alt=""
                                      />
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control searchb ps-0 py-3"
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-default"
                                      placeholder="Search by name..."
                                      onChange={(e) => handleSearch(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mrg_40 ">
                        <div className="clearFix"></div>

                        <div className="bgwhitemain mt-4 mb-5">
                          {annualReportsData && annualReportsData.length > 0 ? (
                            annualReportsData &&
                            annualReportsData.map((annual, index) => (
                              <a
                                href={
                                  annual.file_data && annual.file_data.file_url
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <div className="d-flex bgw align-items-center justify-content-between mx-0 p-3 mb-3">
                                  <div className="d-flex align-items-center">
                                    <img src="/images/New/pdf.png" alt="pdf" />
                                    <h2 className="ms-2 texts">
                                      {annual.title}
                                    </h2>
                                  </div>
                                  <div className="sidearrow">
                                    <img src="/images/New/red-forward-arrow.svg" alt="red-forward-arrow-icon" />
                                  </div>
                                </div>
                              </a>
                            ))
                          ) : (
                            <div className=" bgw align-items-center p-3 mb-3">
                              {" "}
                              <h2>No Result</h2>{" "}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div>
                      <div className="mrg_40">
                        <div className="d-flex d-md-block flex-column-reverse">
                          <div className="row">
                            <div className="col-md-9">
                              <p className="mt-3 fsize">
                                Select the Financial Year to View Reports
                              </p>
                              <div className="row mt-3">
                                <div className="col-md-6 mb-4">
                                  <div className="input-group inputt">
                                    <select
                                      className="form-select year-drop py-3"
                                      id="inputGroupSelect04"
                                      aria-label="Example select with button addon"
                                      onChange={handleSelectChange}
                                    >
                                      {financialYears &&
                                        Object.keys(financialYears).length >
                                          0 &&
                                        Object.keys(financialYears).map(
                                          (year, index) => (
                                            <option value={year}>
                                              {
                                                Object.values(financialYears)[
                                                  index
                                                ]
                                              }
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-6 mb-4">
                                  <div className="input-group mb-3 ipgroup">
                                    <span
                                      className="input-group-text serchcolor"
                                      id="inputGroup-sizing-default"
                                    >
                                      <img
                                        className="search"
                                        src="/images/New/grey-search.svg"
                                        alt=""
                                      />
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control searchb ps-0 py-3"
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-default"
                                      placeholder="Search by name... "
                                      onChange={(e) => handleSearch(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bgwhitemain mt-4">
                          {financialResultsData &&
                          financialResultsData.length > 0 ? (
                            financialResultsData &&
                            financialResultsData.map((financial, index) => (
                              <a
                                href={
                                  financial.file_data &&
                                  financial.file_data.file_url
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <div className="d-flex bgw align-items-center justify-content-between mx-0 p-3 mb-3">
                                  <div className="d-flex align-items-center">
                                    <img src="/images/New/pdf.png" alt="pdf" />
                                    <h2 className="ms-2 texts">
                                      {financial.title}
                                    </h2>
                                  </div>
                                  <div className="sidearrow">
                                    <img src="/images/New/red-forward-arrow.svg" alt="red-forward-arrow-icon" />
                                  </div>
                                </div>
                              </a>
                            ))
                          ) : (
                            <div className=" bgw align-items-center p-3 mb-3">
                              {" "}
                              <h2>No Result</h2>{" "}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="shareholder">
                      <div className="mrg_40">
                        <div className="d-flex d-md-block flex-column-reverse">
                          <div className="row">
                            <div className="col-md-9">
                              <p className="mt-3 fsize">
                                Select the Financial Year to View Reports
                              </p>
                              <div className="row mt-3">
                                <div className="col-md-6 mb-4">
                                  <div className="input-group inputt">
                                    <select
                                      className="form-select year-drop py-3"
                                      id="inputGroupSelect04"
                                      aria-label="Example select with button addon"
                                      onChange={handleSelectChange}
                                    >
                                      {shareholderYears &&
                                        Object.keys(shareholderYears).length >
                                          0 &&
                                        Object.keys(shareholderYears).map(
                                          (year, index) => (
                                            <option value={year}>
                                              {
                                                Object.values(shareholderYears)[
                                                  index
                                                ]
                                              }
                                            </option>
                                          )
                                        )}
                                    </select>
                                  </div>
                                </div>
                                <div className="col-md-6 mb-4">
                                  <div className="input-group ipgroup">
                                    <span
                                      className="input-group-text serchcolor"
                                      id="inputGroup-sizing-default"
                                    >
                                      <img
                                        className="search"
                                        src="/images/New/grey-search.svg"
                                        alt=""
                                      />
                                    </span>
                                    <input
                                      type="text"
                                      className="form-control searchb ps-0 py-3"
                                      aria-label="Sizing example input"
                                      aria-describedby="inputGroup-sizing-default"
                                      placeholder="Search by name..."
                                      onChange={(e) => handleSearch(e)}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {<h3 className="audio mb-3">Audio </h3>}
                        <div className="custAccordian">
                          <div className="accordian tryacord">
                            {shareholderPptAudio &&
                              shareholderPptAudio.length > 0 &&
                              shareholderPptAudio &&
                              shareholderPptAudio.map((item, index) => (
                                <div className="item">
                                  <div
                                    className="title"
                                    onClick={() => toggle(index)}
                                  >
                                    <div className="d-flex align-items-center">
                                      <img src="/images/New/sound.svg" alt="sound-or-audio-icon" />
                                      <h2 className="ms-3">{item.title}</h2>
                                    </div>
                                    
                                      <div>
                                        <img 
                                          className={selected === index ? "rotate" : ""}
                                          src="/images/New/redDownArrow.svg" 
                                          alt="red arrow"
                                        />
                                      </div>
                                    
                                  </div>
                                  <div
                                    className={
                                      selected === index
                                        ? "content show"
                                        : "content"
                                    }
                                  >
                                    <div>
                                      <audio
                                        preload="auto"
                                        className="w-100"
                                        controls
                                        ref={(audio) => (audioRefs.current[index] = audio)}
                                      >
                                        <source
                                          src={item.audio_data.file_url}
                                        />
                                      </audio>
                                    </div>
                                  </div>
                                </div>
                              ))}
                          </div>

                          {/* {shareholderPptAudio &&
                            shareholderPptAudio.length > 0 &&
                            shareholderPptAudio &&
                            shareholderPptAudio.map((item, index) => {
                              return (
                                <Accordian
                                  className=" mb-4"
                                  item={item}
                                  id={index}
                                  key={index}
                                >
                                  <div className="list-content" key={index}>
                                    <div>
                                      <audio
                                        preload="auto"
                                        className="w-100"
                                        controls
                                      >
                                        <source
                                          src={item.audio_data.file_url}
                                        />
                                      </audio>
                                    </div>
                                  </div>
                                </Accordian>
                              );
                            })} */}
                        </div>
                        <div className="clearFix">&nbsp;</div>
                        {<h3 className="pdfcls">PDF's</h3>}
                        <div className="custAccordian">
                          <div className="bgwhitemain mt-4">
                            {shareholderPpt && shareholderPpt.length > 0 ? (
                              shareholderPpt &&
                              shareholderPpt.map((shareholder, index) => (
                                <a
                                  href={
                                    shareholder.file_data &&
                                    shareholder.file_data.file_url
                                  }
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <div className="d-flex bgw align-items-center justify-content-between p-3 mb-3 mx-0">
                                    <div className="d-flex align-items-center">
                                      <img src="/images/New/pdf.png" alt="pdf" />
                                      <h2 className="ms-2 texts">
                                        {shareholder.title}
                                      </h2>
                                    </div>
                                    <div className="sidearrow">
                                      <img src="/images/New/red-forward-arrow.svg" alt="red-forward-arrow-icon" />
                                    </div>
                                  </div>
                                </a>
                              ))
                            ) : (
                              <div className=" bgw align-items-center p-3 mb-3">
                                <h2>No Result</h2>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                </div>

                {totalRecords > 10 && (
                  <div className="container p-0 my-4">
                    <div className="row">
                      <div className="col-md-12 px-3">
                        <div className="paginate d-flex justify-content-center">
                          <PaginationComponent
                            totalRecords={totalRecords}
                            activePage={activePage}
                            setActivePage={setActivePage}
                            data={data}
                            limit={limit}
                            getPaginatedData={getPaginatedData}
                            itemsCountPerPage={limit}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Tabs>
      </section></>:<PageNotFound/>}
    </div>
  );
};

const mapStateToProps = (state) => ({
  financialInformation: state.aboutnew.home,
});

const mapDispatchToProps = (dispatch) => ({
  getAboutUsFinancialInfo: bindActionCreators(
    getAboutUsFinancialInfo,
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinancialInformation);
